module.exports = __webpack_public_path__ + "img/best_on.a23fb3da.svg";